export var TechnicalFoulOptions = ["block", "charge"];
